'use client';

import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { validateEmail } from '@/lib/validateEmail/validateEmail';
import { usePathname } from 'next/navigation';

function PopUp() {
  const pathname = usePathname();
  const isBlogPage = pathname.includes('/blog');

  useEffect(() => {
    !localStorage.getItem('popUp')
      ? setOpenModal(true)
      : setTimeout(() => setOpenModal(true), 30 * 60 * 1000);
  }, []);
  useEffect(() => {
    axios
      .get('https://api.ipify.org/?format=json')
      .then((res) => {
        localStorage.setItem('ipV4', res?.data?.ip);
      })
      .catch((err) => console.log(err));
  }, []);
  const [openModal, setOpenModal] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    const popUp = localStorage.getItem('popUp');
    if (!popUp) {
      setOpenModal(true);
    } else {
      setTimeout(() => setOpenModal(true), 30 * 60 * 1000); // 30 minutes
    }

    const fetchIp = async () => {
      try {
        const res = await axios.get('https://api.ipify.org/?format=json');
        localStorage.setItem('ipV4', res?.data?.ip);
      } catch (err) {
        console.log(err);
      }
    };

    fetchIp();
  }, []);

  const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email.trim()) {
      // inputRef.current?.classList.add("animate-shake-input");
      inputRef.current?.classList.remove('hidden');
      inputRef.current?.classList.add('flex');
    } else {
      if (!validateEmail(email)) {
        setMessage('notValid');
      } else {
        axios
          ?.post(process.env.NEXT_PUBLIC_MAIL_URL as string, {
            Email: email,
            IP: localStorage.getItem('ipV4'),
            CampaignId: 'bede536d-a547-4125-9a34-ef597513b1e5',
            refId: 5,
          })
          .then((res) => {
            console.log('res', res);
            setMessage(res?.data?.result?.message);
          })
          .catch((err) => {
            console.log('err', err);
          });
      }
    }
  };
  const onClose = () => {
    setOpenModal(false);
    localStorage.setItem('popUp', 'true');
  };

  if (!openModal) return null;
  return (
    !isBlogPage &&
    !pathname.includes('/portfolio') && (
      <div className='md:px-0 px-20'>
        <div
          onClick={onClose}
          className='fixed w-full h-full bg-[#000000e3] left-[0] top-[0] z-[999] animate__animated text-white '
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className=' animate-[slideIn_.5s_ease-in-out] absolute w-[330px] sm:w-[370px] md:w-[447px] text-center inset-0 h-fit m-auto bg-[#101827] p-[30px] border-[1px] border-[solid] border-[#24324C] rounded-[24px]  animate__animated animate__bounceInDown'
          >
            <svg
              onClick={onClose}
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth='1.5'
              stroke='currentColor'
              className='cursor-pointer absolute right-[14px] top-[14px] w-[40px]'
            >
              {' '}
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'
              ></path>
            </svg>

            <img
              src='/imgs/popupLogo.svg'
              alt='popupLogo'
              className='block m-auto w-[65px] h-auto mt-[20px]'
            />
            <p className='block font-bold text-[28px] leading-[36px] text-center mt-[20px]'>
              <span className='sp1'>
                Subscribe for
                <br />
                Updates on Hero Coin
              </span>
              {/* <span className="block">Seed Round</span> */}
            </p>
            <p className='text-[18px] leading-[28px] font-normal mt-[17px] px-[5px] py-[0] mb-[40px]'>
              Stay in the loop with exclusive news, insights, and updates.
            </p>

            <form onSubmit={submitHandler}>
              <div className='relative w-full flex flex-col gap-1 text-start mt-5'>
                <label
                  htmlFor='email'
                  className='text-[15px] text-hero-sky-545 pl-7'
                ></label>
                <input
                  ref={inputRef}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    inputRef.current?.classList.add('hidden');

                    inputRef.current?.classList.remove('flex');
                  }}
                  placeholder='Enter Your Email'
                  className='w-full bg-hero-slate-dark rounded-full border border-hero-sky-545 border-opacity-40 font-medium text-hero-sky-545 px-6 h-[56px]'
                />
                <div
                  ref={inputRef}
                  className=' justify-center pt-3 gap-1 hidden'
                >
                  <img alt={'close logo'} src={'/icons/close.svg'} />
                  <p className='text-center text-sm  text-red-400'>
                    Enter your email address.
                  </p>
                </div>
              </div>
              <div className='  flex justify-center'>
                {' '}
                {message === 'notValid' ? (
                  <p className='text-[13px] mt-4 text-red-400 font-medium flex items-center gap-1'>
                    {/* <IoIosCloseCircleOutline size="18px" className="fill-red-500" /> */}
                    <div>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20px'
                        height='20px'
                        viewBox='0 0 24 24'
                        fill='none'
                      >
                        <circle
                          cx='12'
                          cy='12'
                          r='10'
                          stroke='#d15656'
                          strokeWidth='1.5'
                        ></circle>
                        <path
                          d='M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5'
                          stroke='#d15656'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                        ></path>
                      </svg>
                    </div>
                    Invalid email address.
                  </p>
                ) : message === 'unconfirmed' ? (
                  <p className='text-[13px] mt-3 text-yellow-300 font-medium flex items-center gap-1'>
                    {/* <MdMarkEmailRead size="18px" className="fill-yellow-300" /> */}
                    <div>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20px'
                        height='20px'
                        viewBox='0 0 24 24'
                        fill='none'
                      >
                        <path
                          d='M16.0303 10.0303C16.3232 9.73744 16.3232 9.26256 16.0303 8.96967C15.7374 8.67678 15.2626 8.67678 14.9697 8.96967L10.5 13.4393L9.03033 11.9697C8.73744 11.6768 8.26256 11.6768 7.96967 11.9697C7.67678 12.2626 7.67678 12.7374 7.96967 13.0303L9.96967 15.0303C10.2626 15.3232 10.7374 15.3232 11.0303 15.0303L16.0303 10.0303Z'
                          fill='#c8bd3e'
                        ></path>
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z'
                          fill='#c8bd3e'
                        ></path>
                      </svg>
                    </div>
                    Confirmation email sent.
                  </p>
                ) : message === 'reject' ? (
                  <p className='text-[13px] mt-1 mb-3 text-white/55 font-medium flex items-center gap-1'>
                    {/* <IoIosCloseCircleOutline size="18px" className="fill-red-500" /> */}
                    Please try a few more times.
                  </p>
                ) : message === 'active' ? (
                  <p className='text-[13px] mt-4 text-green-500 font-medium flex items-center gap-1'>
                    {/* <IoIosCloseCircleOutline size="18px" className="fill-red-500" /> */}
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='20px'
                      height='20px'
                      viewBox='0 0 24 24'
                      fill='none'
                    >
                      <path
                        d='M16.0303 10.0303C16.3232 9.73744 16.3232 9.26256 16.0303 8.96967C15.7374 8.67678 15.2626 8.67678 14.9697 8.96967L10.5 13.4393L9.03033 11.9697C8.73744 11.6768 8.26256 11.6768 7.96967 11.9697C7.67678 12.2626 7.67678 12.7374 7.96967 13.0303L9.96967 15.0303C10.2626 15.3232 10.7374 15.3232 11.0303 15.0303L16.0303 10.0303Z'
                        fill='#6ad156'
                      ></path>
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z'
                        fill='#6ad156'
                      ></path>
                    </svg>
                    Your email is already active
                  </p>
                ) : (
                  ''
                )}
              </div>
              <button
                className='flex disabled:cursor-wait items-center justify-center gap-1 rounded-full mt-[18px] font-bold text-[16px] bg-[#1CA0DB] h-[50px] w-full'
                type='submit'
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    )
  );
}

export default PopUp;
